export const AI_PROVIDERS = ['auto', 'groq', 'mistral', 'cerebras', 'claude'] as const;

export type AiProvider = (typeof AI_PROVIDERS)[number];

const STORAGE_KEY = 'suivifinance-ai-provider';

export function normalizeProvider(value: string | null | undefined): AiProvider {
  const v = String(value || 'auto').toLowerCase().trim();
  return (AI_PROVIDERS as readonly string[]).includes(v) ? (v as AiProvider) : 'auto';
}

export function readStoredProvider(): AiProvider {
  try {
    return normalizeProvider(localStorage.getItem(STORAGE_KEY));
  } catch {
    return 'auto';
  }
}

export function storeProvider(provider: AiProvider): void {
  try {
    localStorage.setItem(STORAGE_KEY, provider);
  } catch {
    /* ignore */
  }
}

export function aiProviderOptionLabel(provider: AiProvider): string {
  const labels: Record<AiProvider, string> = {
    auto: 'Auto (Groq → Mistral → Cerebras → Claude)',
    groq: 'Groq',
    mistral: 'Mistral',
    cerebras: 'Cerebras',
    claude: 'Claude',
  };
  return labels[provider];
}

export function formatAiProviderName(provider: string | null | undefined): string {
  const s = String(provider || '').trim();
  if (!s || s === 'auto') return 'Auto';
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
}
